/**
 * Value stored on dealer_users.talklive_instances.
 * Must be the instance's instance_id, the same string written on each
 * conversation as talklive_instance_id. Do not derive it from the label:
 * "Service - RDV" with id "service" must be stored as "service".
 */
export function getInstanceStorageValue(instance) {
  return instance.instance_id || '';
}

export function getInstanceDisplayLabel(instance) {
  return instance.label || instance.instance_id || '';
}

export function normalizeTalkliveInstancesResponse(data) {
  if (Array.isArray(data)) return data;
  return data?.instances || [];
}
